export default __webpack_public_path__ + "static/media/Logo.cf2813e0.png";